const SECTOR_PALETTE = [
	"#262626",
	"#D62839",
	"#3DA5F4",
	"#b3a90f",
	"#8F5220",
	"#1E5296",
	"#1E6B3A",
	"#E8721C",
	"#a954cc",
	"#ed76b3",
	"#5B4FE8",
	"#12c281",
]
const GOLDEN_ANGLE = 137.508
const overflowSectorColor = (index: number) => {
	const step = index - SECTOR_PALETTE.length
	const lightness = step % 2 === 0 ? 55 : 68
	return `oklch(${lightness}% 0.16 ${(step * GOLDEN_ANGLE) % 360})`
}
export const sectorColorForIndex = (index: number) =>
	SECTOR_PALETTE[index] ?? overflowSectorColor(index)

export const FALLBACK_COLOR = "#8e9aab"
export const DEPOT_COLOR = "#37474F"
export const SELECTION_COLOR = "#F5A623" // ring color for a selected marker

// Hides POI/transit icons and mutes road labels for a cleaner basemap.
export const MAP_STYLE: google.maps.MapTypeStyle[] = [
	{ featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
	{
		featureType: "transit",
		elementType: "all",
		stylers: [{ visibility: "off" }],
	},
	{
		featureType: "road",
		elementType: "labels.icon",
		stylers: [{ visibility: "off" }],
	},
	{
		featureType: "administrative",
		elementType: "labels.text.fill",
		stylers: [{ color: "#8e9aab" }],
	},
]
